import React from 'react';

import { graphql } from 'gatsby';

import BlockColumnsSectionDS from 'design-system/src/components/organisms/BlockColumnsSection';
import { getSrc } from '../../utils/media';

export default function BlockColumnsSection({ items, ...props }: any) {
    const mappedItems = items?.length
        ? items
              .map((item) => ({
                  ...item,
                  text: item?.description,
                  icon: getSrc(item.icon),
              }))
              .filter(Boolean)
        : [];

    return <BlockColumnsSectionDS {...props} items={mappedItems} />;
}

export const query = graphql`
    fragment DatoCmsBlockColumnsSection on DatoCmsBlockColumnsSection {
        preTitle
        title
        text: description
        items {
            ...Point
        }
    }
`;
